/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import InfoModal from '../../../shared-components/common/InfoModal';

const propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
};

function PereMarquetteInfoModal({ isOpen, closeModal }) {
    return (
        <InfoModal
            isOpen={isOpen}
            closeModal={closeModal}
            title="How watercraft calculation works"
        >
            <div>
                <div className="rec-modal-sub-title">
                    Pere Marquette River Permit Policy
                </div>
                <ul>
                    <li>Each reservation is limited to a maximum of 8 watercraft.</li>
                    <li>
                        A maximum of four reserved trip dates, made one at a time,
                        including a holiday weekend, per person, will be allowed.
                    </li>
                    <li>
                        Watercraft permits are required for all watercraft, including
                        tubes, from the Friday of Memorial Day Weekend through the Monday
                        of Labor Day Weekend for a fee of $2.
                    </li>
                    <li>Watercraft hours are 9 a.m. to 6 p.m.</li>
                    <li>
                        Much of the river corridor is privately owned. Use only public
                        sites for rest stops. Respect private property.
                    </li>
                    <li>
                        Each watercraft occupant must have a personal flotation device
                        (PFD), children 6 and under must wear a PFD at all times.
                    </li>
                    <li>Camping and campfires at designated sites only.</li>
                    <li>
                        Fireworks, nudity, glass bottles and styrofoam are not permitted.
                    </li>
                </ul>
                <div className="rec-modal-sub-title">
                    Make a Reservation: Combination of Watercraft
                </div>
                <p>
                    For a permit including a combination of watercraft on the Pere
                    Marquette, please review the new watercraft values below. After
                    selecting &quot;Watercraft Quota&quot; from the adjacent drop-down
                    menu, the system will prompt you to enter the number of
                    &quot;Watercraft.&quot; The new reservation system has assigned a
                    value to each type of watercraft. You will need to total your
                    watercraft according to the following new values:
                </p>
                <ul>
                    <li>1 tube equals 0.5 quota</li>
                    <li>1 kayak equals 0.5 quota</li>
                    <li>1 tandem kayak equals 1 quota</li>
                    <li>1 canoe equals 1 quota</li>
                    <li>1 driftboat equals 1 quota</li>
                    <li>1 raft equals 2 quota</li>
                </ul>
            </div>
        </InfoModal>
    );
}

PereMarquetteInfoModal.propTypes = propTypes;

export default PereMarquetteInfoModal;
